import { render, staticRenderFns } from "./enterprise-dishes.vue?vue&type=template&id=e64e39ee&"
import script from "./enterprise-dishes.vue?vue&type=script&lang=js&"
export * from "./enterprise-dishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports